import {initializeApp} from 'firebase/app';
import {firebaseConfig} from "./config";

initializeApp(firebaseConfig)
